import { ProgramSettingsResp } from '@/storage/program_settings/requests'
import { format, isWithinInterval, parse, parseISO } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'

export function formatProgramWindowDate(date: Date | undefined | null) {
  if (!date || isNaN(date.getTime())) return 'Invalid date'
  return format(date, 'MMMM dd, yyyy h:mm aa')
}

export function YYYYMMDDToDate(date: string) {
  const parsedDate = parse(date, 'yyyy-MM-dd', new Date())

  return parsedDate
}

export function UTCToUsersTimezone(dateString: string) {
  const parsedDate = parseISO(dateString)
  const formatted = format(parsedDate, 'yyyy-MM-dd hh:mm:ss a')
  return formatted
}

export function getProgramStartTimeInUsersTimezone(
  startDate: string,
  timezone: string
) {
  const startTime = `${startDate}T00:00:00.000`

  const date = fromZonedTime(startTime, timezone)

  return date
}

export function getProgramEndTimeInUsersTimezone(
  endTime: string,
  timezone: string
) {
  const endTimeString = `${endTime}T23:59:59.999`

  const date = fromZonedTime(endTimeString, timezone)
  return date
}

export function isApplicationWindowOpen(programSettings: ProgramSettingsResp) {
  const {
    global_timezone_code,
    new_application_start_date,
    new_application_end_date,
  } = programSettings

  const timezone = global_timezone_code

  const startTime = getProgramStartTimeInUsersTimezone(
    new_application_start_date,
    timezone
  )

  const endTime = getProgramEndTimeInUsersTimezone(
    new_application_end_date,
    timezone
  )

  return isWithinInterval(new Date(), {
    start: startTime,
    end: endTime,
  })
}
